(() => {
  const wrapper = document.querySelector('.gainr-tracking');
  if (!wrapper) return;
  const label = wrapper.dataset.trackLabel;
  const updateLabels = () => {
    wrapper.querySelectorAll('.track123_form_button').forEach(button => {
      if (!button.disabled && button.childElementCount === 0 && button.textContent !== label) button.textContent = label;
    });
  };
  updateLabels();
  new MutationObserver(updateLabels).observe(wrapper, {childList: true, subtree: true});
})();
